const app = require('angular').module('wowApp.shop');
app.value('enableOnPage', { '/search/': true, '/search': true });
app.directive('bwsReturnToTop', ['enableOnPage', 'jQuery', '$window', 'BreakpointsService', require('./return-to-top-directive')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/return-to-top/index.js
 **/